import { useState } from 'react';
import { Filter } from 'bad-words'; 

const useProfanityFilter = () => {
  const [filteredText, setFilteredText] = useState('');
  const [containsProfanity, setContainsProfanity] = useState(false);

  const filter = new Filter(); // Initialize bad-words filter

  const checkProfanity = (text) => {
    if (!text) return '';

    const isProfane = filter.isProfane(text);
    setContainsProfanity(isProfane);

    // Either block or censor the profanity
    const cleanedText = isProfane ? filter.clean(text) : text;
    setFilteredText(cleanedText);

    return cleanedText;
  };

  return { filteredText, containsProfanity, checkProfanity };
};

export default useProfanityFilter;
